import styled from "@emotion/styled";
import { FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";
import { Button } from "components/UI";
import { useChurchStore } from "features/churches";
import {
  useBanks,
  useExpenseStore,
  usePaymentRequisition
} from "features/finances";
import { useState } from "react";
import { BaseModal } from "./BaseModal";

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Label = styled.label`
  color: #5b5b5b;
  font-size: 12px;
  font-weight: 500;
`;

const Input = styled.input`
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  height: 40px;
  outline: none;
  padding: 8px;
`;

const Select = styled.select`
  border-radius: 4px;
  border: 0.73px solid #b3b3b3;
  height: 40px;
  outline: none;
  padding: 8px;
  font-family: inherit;
  background-color: transparent;
`;

export function MakePaymentModal({ data }) {
  const makePaymentOpen = useExpenseStore(state => state.makePaymentOpen);
  const closeMakePaymentModal = useExpenseStore(
    state => state.closeMakePaymentModal
  );
  const paymentMutation = usePaymentRequisition();
  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const [paymentMethod, setPaymentMethod] = useState("CHEQUE");
  const [chequeNumber, setChequeNumber] = useState("");
  const [bankId, setBankId] = useState("");

  const banksQuery = useBanks({
    churchId: selectedChurch?.id
  });

  const handleMakePayment = () => {
    paymentMutation.mutate(
      {
        churchId: selectedChurch?.id,
        requisitionId: data?.id,
        requisitionData: {
          payment_method: paymentMethod,
          ...(paymentMethod === "CHEQUE" && {
            cheque_number: chequeNumber,
            bank_id: bankId
          })
        }
      },
      {
        onSuccess: () => {
          closeMakePaymentModal();
        }
      }
    );
  };

  return (
    <BaseModal
      title="Make Payment"
      isOpen={makePaymentOpen}
      onClose={closeMakePaymentModal}
      footer={
        <Stack direction="row" justifyContent="flex-end" spacing={2}>
          <Button
            flavor="white"
            size="small"
            disabled={paymentMutation.isLoading}
          >
            Cancel
          </Button>
          <Button
            size="small"
            onClick={handleMakePayment}
            disabled={paymentMutation.isLoading}
          >
            Submit
          </Button>
        </Stack>
      }
      minHeight="200px"
    >
      <RadioGroup
        value={paymentMethod}
        onChange={e => setPaymentMethod(e.target.value)}
        sx={{
          alignSelf: "flex-start"
        }}
      >
        <FormControlLabel value="CHEQUE" control={<Radio />} label="Cheque" />
        <FormControlLabel value="CASH" control={<Radio />} label="Cash" />
      </RadioGroup>
      {paymentMethod === "CHEQUE" && (
        <Field>
          <Label htmlFor="chequeNumber">Cheque Number</Label>
          <Input
            id="chequeNumber"
            value={chequeNumber}
            onChange={e => setChequeNumber(e.target.value)}
          />
        </Field>
      )}
      {paymentMethod === "CHEQUE" && (
        <Field>
          <Label htmlFor="bank">Bank Account</Label>
          <Select
            id="bank"
            value={bankId}
            onChange={e => setBankId(e.target.value)}
          >
            <option value="" disabled>
              Select Bank
            </option>
            {banksQuery.data?.result?.map(bank => (
              <option key={bank.id} value={bank.id}>
                {bank.name}
              </option>
            ))}
          </Select>
        </Field>
      )}
    </BaseModal>
  );
}
